module.exports = __webpack_public_path__ + "img/triangule.0227fc86.svg";